routerConfig.$inject = [
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider'
];

export function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true).hashPrefix('!');
    $stateProvider
        .state({
            abstract: true,
            name: 'app',
            views: {
                '': { template: '<app></app>' }
            }
        });
       $urlRouterProvider.otherwise('/login');
}



// WEBPACK FOOTER //
// ./src/router.js